import React from 'react';

import styled from 'styled-components';
import { colors } from 'z-react-components';
import { FeatherIcon } from '@zanichelli/react-components';
import { animateScroll } from 'react-scroll';

import Main from './sections/main';
import Subjects from './sections/subjects';
import LoginAndSignUp from './sections/LoginAndSignUp';
import Stats from './sections/stats';
import Video from './sections/video';
import Quotes from './sections/quotes';

const Container = styled.div`
    display: flex;
    flex-direction: column;

    background-color: white;
`;

const CarouselContainer = styled.div`
    background-color: ${colors.grey100};
    padding: 16px 0;
`;

const SubjectsContainer = styled.div`
    background-color: white;
    margin: 64px 0;
`;

const LoginContainer = styled.div`
    background-color: white;
`;

const StatsContainer = styled.div`
    background-color: ${colors.orange};
    color: white;
    padding: 16px 0;
`;

const VideosContainer = styled.div`
    background-color: white;
`;

const QuotesContainer = styled.div`
    background-color: rgb(85, 179, 192);
    color: white;
    padding: 16px 0;
`;

const Subtitle = styled.h2`
    font-weight: bold;
    text-align: center;
    margin-bottom: 32px;
`;

export const ScrollerToTop = styled.div`
    background: ${colors.grey900};
    color: ${colors.white};
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
    height: 72px;
    width: 72px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    font-weight: bold;
    position: fixed;
    right: 32px;
    bottom: 32px;
    visibility: hidden;
    cursor: pointer;
    z-index: 9;

    @media screen and (max-width: 745px) {
        visibility: visible;
    }
`;

const LandingV2 = () => (
    <Container>
        <CarouselContainer>
            <Main />
        </CarouselContainer>
        <SubjectsContainer>
            <Subjects />
        </SubjectsContainer>
        <Subtitle>
            {'Hai trovato la tua materia?'}
            <br />
            {'Inizia ora ad usare Crea Verifiche'}
        </Subtitle>
        <LoginContainer>
            <LoginAndSignUp />
        </LoginContainer>
        <StatsContainer>
            <Stats />
        </StatsContainer>
        <VideosContainer>
            <Video />
        </VideosContainer>
        <QuotesContainer>
            <Quotes />
        </QuotesContainer>
        <ScrollerToTop onClick={() => animateScroll.scrollToTop({ duration: 200 })}>
            <FeatherIcon name={'arrow-up'} size={16} />
            {'ACCEDI'}
        </ScrollerToTop>
    </Container>
);

export default LandingV2;
